import React from "react";
import { FormGroup, FormLabel } from "react-bootstrap";
import { useFormContext, Controller } from "react-hook-form";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const MultiSelect = ({
    label,
    name,
    rules,
    options = [],
    placeholder = "",
    containerProps,
    selectProps,
}) => {
    const { t } = useTranslation();
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <FormGroup className="mb-3" {...containerProps}>
            {label && <FormLabel htmlFor={name}>{label}{rules?.required && <span className="text-danger ms-1">*</span>}</FormLabel>}
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => (
                    <Select
                        {...field}
                        isMulti
                        options={options}
                        placeholder={placeholder || t("PLEASE_SELECT")}
                        value={field.value || []}
                        onChange={(selected) => field.onChange(selected)}
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: errors[name] ? "red" : base.borderColor,
                            }),
                        }}
                        {...selectProps}
                    />
                )}
            />
            {errors[name] && (
                <div className="text-danger mt-1">
                    {errors[name]?.message}
                </div>
            )}
        </FormGroup>
    );
};

export default MultiSelect;
